/*
 * -----------------------------------------------------------------------
 *  <copyright file="dialog-information-box.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'clsx';
import React from 'react';

import './dialog-information-box.scss';
import {
    DialogInformationBoxProps,
    InfoBoxIcons,
} from '@components/core/dialog-information-box/dialog-information-box.interface';

const DialogInformationBox = ({
    topText,
    bottomText,
    boxStyleClass,
    icon = InfoBoxIcons.infoCircle,
}: DialogInformationBoxProps) => (
    <div className={cn('info-box', boxStyleClass)}>
        <div className="guideline-icon">
            <FontAwesomeIcon icon={['fal', icon]} />
        </div>
        <div>
            <div className="guideline-text" dangerouslySetInnerHTML={{ __html: topText }} />
            {bottomText && (
                <div className="guideline-text example-text" dangerouslySetInnerHTML={{ __html: bottomText }} />
            )}
        </div>
    </div>
);

export default DialogInformationBox;
